// import newC from "./assets/slideshow/newC.jpg"
// import newD from "./assets/slideshow/newD.jpg"
// import newE from "./assets/slideshow/newE.jpg"
// import newF from "./assets/slideshow/newF.jpg"
// import newG from "./assets/slideshow/newG.jpg"
// import newH from "./assets/slideshow/newH.jpg"
import NewI from "./assets/slideshow/NewI.jpg"
import NewIm from "./assets/slideshow/NewIm.jpg"
import NewIma from "./assets/slideshow/NewIma.jpg"
import NewImag from "./assets/slideshow/NewImag.jpg"
import NewImage from "./assets/slideshow/NewImage.jpg"
import NewImage1 from "./assets/slideshow/NewImage1.jpg"

import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

const images = [NewI, NewIm, NewIma, NewImag, NewImage, NewImage1]

export const Home = () => {
	const [index, set_index] = useState(0)
	const navigate = useNavigate()

	useEffect(() => {
		const int = setInterval(() => set_index((index + 1) % images.length), 5_000)
		return () => clearInterval(int)
	})

	return (
		<div
			onClick={() => set_index((index + 1) % images.length)}
			className="w-full relative h-[81vh]"
		>
			<img
				src={images[index]}
				className="absolute w-full max-h-[81vh] object-cover object-center"
			/>
			<button
				onClick={() => navigate("/urban/new")}
				className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-500 text-white font-medium text-2xl py-4 px-6 rounded-md"
			>
				Efectuar trámite
			</button>
		</div>
	)
}
